module.exports = __webpack_public_path__ + "img/science_committee.a548e0e3.jpg";